export default __webpack_public_path__ + "static/media/about4.c9af0d52.jpg";